import type { PropsWithChildren } from 'react';
import { useMemo, useState } from 'react';
import {
  DemoToggleContext,
  type DemoToggleState
} from '../hooks/use-demo-toggle';

export function DemoToggleProvider({ children }: PropsWithChildren) {
  const [toggleState, setToggleState] = useState<DemoToggleState>('before');

  const value = useMemo(() => ({ toggleState, setToggleState }), [toggleState]);

  return (
    <DemoToggleContext.Provider value={value}>
      {children}
    </DemoToggleContext.Provider>
  );
}
